/* import __COLOCATED_TEMPLATE__ from './next-steps-panel.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed, action } from '@ember/object';

export default class NextStepsPanel extends Component {
    tagName = '';

    @service('aditools-analytics') analytics;
    @service pdfExport;
    @service ltSpice;
    @service partData;
    @service selectionData;

    @computed('selectionData.{selectedAdc.disableLTspice,selectedDriver.disableLTspice}')
    get disableLtSpiceSimulation() {
        return (
            this.selectionData.selectedAdc.disableLTspice || this.selectionData.selectedDriver.disableLTspice || false
        );
    }

    @action downloadSummary(event) {
        this.blurButton(event);
        this.analytics.setWebEvent(
            this.partData.toolName,
            `downloadSummary`,
            '', // data
        );

        this.pdfExport.generatePdf();
    }

    @action downloadLtspice(event) {
        this.blurButton(event);
        this.analytics.setWebEvent(
            this.partData.toolName,
            `downloadLtspice`,
            '', // data
        );

        this.ltSpice.downloadSimulation();
    }

    @action refreshPage() {
        window.location.reload();
    }

    // De-focus a button after it's been clicked.
    blurButton(event) {
        event = event || window.event;
        event.target.blur();
    }
}
